module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addr_new"
  }, [_c('header', {
    staticClass: "page_head"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "right_btn",
    attrs: {
      "id": "save_address",
      "href": "javascript:;"
    },
    on: {
      "click": _vm.saveaddress
    }
  }, [_vm._v("保存")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "addressForm",
      "method": "",
      "onsubmit": "return false",
      "action": ""
    }
  }, [_c('div', {
    staticClass: "addressErrorMessage"
  }, [_vm._v(_vm._s(_vm.addressErrorMessage))]), _vm._v(" "), _c('p', {
    staticClass: "item_wrap"
  }, [_c('label', {
    attrs: {
      "for": "addressUser"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressUser),
      expression: "addressUser"
    }],
    attrs: {
      "type": "text",
      "placeholder": "收货人",
      "id": "addressUser",
      "name": "realName",
      "value": ""
    },
    domProps: {
      "value": (_vm.addressUser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressUser = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "item_wrap"
  }, [_c('label', {
    attrs: {
      "for": "validatePhoneOrMobile"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressPhone),
      expression: "addressPhone"
    }],
    attrs: {
      "placeholder": "联系电话",
      "id": "validatePhoneOrMobile",
      "type": "tel",
      "name": "mobile",
      "value": ""
    },
    domProps: {
      "value": (_vm.addressPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressPhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "item_wrap"
  }, [_c('label', {
    staticClass: "select_box",
    attrs: {
      "for": "addressPid"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPidShow),
      expression: "isPidShow"
    }],
    staticClass: "notice note_show"
  }, [_vm._v("所在省份")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressPid),
      expression: "addressPid"
    }],
    attrs: {
      "id": "addressPid",
      "name": "province"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addressPid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectChangeP]
    }
  }, _vm._l((_vm.province), function(li, index) {
    return _c('option', {
      key: li.id,
      domProps: {
        "value": li.id
      }
    }, [_vm._v(_vm._s(li.name))])
  })), _vm._v(" "), _c('span', {
    staticClass: "select_btn"
  }, [_vm._v("请选择")])])]), _vm._v(" "), _c('p', {
    staticClass: "item_wrap"
  }, [_c('label', {
    staticClass: "select_box",
    attrs: {
      "for": "addressCid"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCidShow),
      expression: "isCidShow"
    }],
    staticClass: "notice note_show"
  }, [_vm._v("所在城市")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressCid),
      expression: "addressCid"
    }],
    attrs: {
      "id": "addressCid",
      "name": "city"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addressCid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectChangeC]
    }
  }, _vm._l((_vm.city), function(li, index) {
    return _c('option', {
      domProps: {
        "value": li.id
      }
    }, [_vm._v(_vm._s(li.name))])
  })), _vm._v(" "), _c('span', {
    staticClass: "select_btn"
  }, [_vm._v("请选择")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "item_wrap"
  }, [_c('label', {
    staticClass: "select_box",
    attrs: {
      "for": "addressDid"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDidShow),
      expression: "isDidShow"
    }],
    staticClass: "notice note_show"
  }, [_vm._v("所在地区")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressDid),
      expression: "addressDid"
    }],
    attrs: {
      "id": "addressDid",
      "name": "area"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addressDid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectChangeD]
    }
  }, _vm._l((_vm.area), function(li, index) {
    return _c('option', {
      domProps: {
        "value": li.id
      }
    }, [_vm._v(_vm._s(li.name))])
  })), _vm._v(" "), _c('span', {
    staticClass: "select_btn"
  }, [_vm._v("请选择")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "item_wrap"
  }, [_c('label', {
    attrs: {
      "for": "addressStreet"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressStreet),
      expression: "addressStreet"
    }],
    attrs: {
      "id": "addressStreet",
      "type": "text",
      "name": "address",
      "placeholder": "详细地址(必填)",
      "value": ""
    },
    domProps: {
      "value": (_vm.addressStreet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressStreet = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "item_wrap"
  }, [_c('label', {
    attrs: {
      "for": "addressPostcode"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressPostcode),
      expression: "addressPostcode"
    }],
    attrs: {
      "id": "addressPostcode",
      "type": "tel",
      "name": "zip",
      "value": "",
      "placeholder": "邮政编码(选填)"
    },
    domProps: {
      "value": (_vm.addressPostcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressPostcode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item_wrap"
  }, [_c('div', {
    staticClass: "set_wrap"
  }, [_c('span', [_vm._v("设为默认地址")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "name": "isDefault",
      "id": "is_default",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch_btn",
    class: {
      'switch_check': _vm.isDefault == 1, 'switch_uncheck': _vm.isDefault != 1
    },
    on: {
      "click": _vm.isuncheck
    }
  }, [_c('i', {
    staticClass: "inner_circle"
  })])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAddrBtnShow),
      expression: "isAddrBtnShow"
    }],
    staticClass: "remove_addr_btn",
    on: {
      "click": _vm.delAddr
    }
  }, [_vm._v(" 删除此地址 ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMaskShow),
      expression: "isMaskShow"
    }],
    staticClass: "windowDrive"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog",
    staticStyle: {
      "top": "22.0009%"
    },
    attrs: {
      "id": "alert"
    }
  }, [_c('div', {
    staticClass: "dialog-con"
  }, [_vm._v("非常抱歉，您还未登陆，请先登录后查看")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-btn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', {
    staticClass: "sureBtn"
  }, [_vm._v("确认")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back_icon",
    attrs: {
      "id": "back_btn"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:history.go(-1)"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://s17.mogucdn.com/p1/160922/idid_ie3wmnbvgftginzsmizdambqgayde_35x52.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("收货地址")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "submitBox",
    staticStyle: {
      "display": "none"
    }
  }, [_c('input', {
    staticClass: "addressBtn button",
    attrs: {
      "type": "submit",
      "value": "保存地址"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-dca3e196", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-dca3e196","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/jaddaddrcont.vue
// module id = 295
// module chunks = 0